import { createSignal } from '@verclam/pulsar';

export type ProviderSidebarContext = {
	readonly providerId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the provider carried by `providerId`; a
 * `providerId` of `null` inside an open context creates one instead.
 */
const providerSidebarSignal = createSignal<ProviderSidebarContext | null>(null);

export const openProviderSidebar = (providerId: number | null): void => {
	providerSidebarSignal.value = { providerId };
};

export const closeProviderSidebar = (): void => {
	providerSidebarSignal.value = null;
};

export default providerSidebarSignal;
